export class NewsletterSubscibermodel {
    EmailAddress:string;
    EnterprisePartnerID:number;
    //NewsletterSubscriberID:number;
}
